import { render, staticRenderFns } from "./confirmation.vue?vue&type=template&id=56e83b52&scoped=true"
import script from "./confirmation.vue?vue&type=script&lang=js"
export * from "./confirmation.vue?vue&type=script&lang=js"
import style0 from "./confirmation.vue?vue&type=style&index=0&id=56e83b52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e83b52",
  null
  
)

export default component.exports